










































import { Vue, Component } from "vue-property-decorator";
import "animate.css";
@Component({
  name: "Element",
})
export default class Element extends Vue {
  //https://animate.style/ 可继续扩充查看实例
  private animate = [
    "animate__bounce",
    "animate__flash",
    "animate__pulse",
    "animate__rubberBand",
    "animate__shakeX",
    "animate__shakeY",
    "animate__headShake",
    "animate__swing",
    "animate__tada",
    "animate__wobble",
    "animate__jello",
    "animate__heartBeat",
    "animate__backInDown",
    "animate__backInLeft",
    "animate__backInRight",
    "animate__backInUp",
    "animate__backOutDown",
    "animate__backOutLeft",
    "animate__backOutRight",
    "animate__backOutUp",
    "animate__bounceIn",
    "animate__bounceInDown",
    "animate__bounceInLeft",
    "animate__bounceInRight",
    "animate__bounceInUp",
  ];
  private animateDoing = "";
  private modalVisible = false;
  private modalIsIn = false;

  private open() {
    this.modalVisible = true;
    this.modalIsIn = true;
  }
  private close() {
    this.modalIsIn = false;
  }
}
